module.exports = __webpack_public_path__ + "img/login-logo.5514178a.png";